export default __webpack_public_path__ + "static/media/me.80119e1a.webp";